module.exports = [{"type":"title","text":"2023-06-03"},{"type":"normal","text":"新版本API文檔網站發佈","style":{"font-weight":"bold"},"children":[{"type":"normal","text":"新版本UI和交互"},{"type":"normal","text":"demo代碼自動生成器,代碼一鍵複製"},{"type":"normal","text":"接口參數表格和JSON之間快速轉換，代碼一鍵全複製，減輕開發者複製API參數的麻煩"},{"type":"normal","text":"新增全文模糊檢索功能"},{"type":"normal","text":"新增郵件訂閱功能，以後有API版本更新會通過郵件通知開發者"},{"type":"normal","text":"新增問題反饋功能，開發者發現API問題可通過本站點直接反饋到BingX team"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-06-03.json
// module id = jVl+
// module chunks = 3